import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { MoonLoader } from 'react-spinners'
import UIMessages from 'src/utils/ui-messages'
import Modal from '../ui/Modal'
import { Input, MbscSelectChangeEvent, Select } from '@mobiscroll/react-latest'

interface IRecurringTripProps extends RouteComponentProps {
  currentTripId: string
  loading: boolean
  cronTabExp: string
  timesToRecur: number
  runForever: boolean
  setCronTabExpression: (cronTabExpression?: string) => void
  setRunForever: (runForever?: boolean) => void
  setTimesToRecur: (timeToRecur?: number) => void
}

const days = [
  { text: 'Sunday', value: 0 },
  { text: 'Monday', value: 1 },
  { text: 'Tuesday', value: 2 },
  { text: 'Wednesday', value: 3 },
  { text: 'Thursday', value: 4 },
  { text: 'Friday', value: 5 },
  { text: 'Saturday', value: 6 }
]
const endOptions = [{ text: 'Never', value: true }, { text: 'Yes', value: false }]
const minimumDaysToRecur = 2
const maximumDaysToRecur = 100
export const RecurringTripModal = (props: IRecurringTripProps) => {
  const [selectedDays, setDays] = React.useState([8])
  const [runForever, setRunForever] = React.useState(endOptions[0])
  const [showModal, setShowModal] = React.useState(true)
  React.useEffect(() => {
    props.setRunForever(endOptions[0].value)
    props.setTimesToRecur(minimumDaysToRecur)
  }, [])

  const setDaysArr = (values: MbscSelectChangeEvent) => {
    setDays(values.value)
    makeCronTabExpression(values.value)
  }
  const makeCronTabExpression = (daysArr: number[]) => {
    const sortedDayArr = daysArr.sort()
    const dayNameArr: string[] = []
    sortedDayArr.forEach(item => {
      const dayObject = days.find(day => day.value === item)
      if (dayObject) {
        dayNameArr.push(dayObject.text)
      }
    })
    const daysArrString = dayNameArr.join(',')
    if (daysArr.length > 0) {
      return props.setCronTabExpression(`* * ${daysArrString}`)
    }
    return props.setCronTabExpression(undefined)
  }
  const setRunForeverValue = (value: MbscSelectChangeEvent) => {
    const runForever = {
      value: value.value,
      text: value.valueText ? value.valueText : ''
    }
    setRunForever(runForever)
    props.setRunForever(value.value)
    if (value.value === true) {
      props.setTimesToRecur(minimumDaysToRecur) // recurring times is ignored in the backend if it never ends. Set to this value for uniformity
    }
  }

  const setTimeToOccurVal = (event: any) => {
    if (event.target.value >= 2 && event.target.value <= 100) {
      props.setTimesToRecur(event.target.value)
    } else if (event.target.value >= 100) {
      props.setTimesToRecur(maximumDaysToRecur)
    } else {
      props.setTimesToRecur(minimumDaysToRecur)
    }
  }
  const cancel = () => {
    setShowModal(false)
  }
  const onSubmit = () => {
    setShowModal(false)
  }
  return (
    <div>
      {showModal && (
        <Modal>
          <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
            <div className='med-modal'>
              <span className='ModalAddTitle font-small weight-300 font-grey2 uppercase'>
                {UIMessages.common.scheduleRecurringRide}
              </span>
              <div className='mt1 border-top pt2'>
                <div className='mt1'>
                  <Select
                    classNamePrefix='select-control'
                    data={days}
                    onChange={value => setDaysArr(value)}
                    tagInput={true}
                    selectMultiple={true}
                    cssClass='mobiscroll-select'
                    touchUi={false}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={'Days to Schedule'}
                    labelStyle='floating'
                  />
                </div>
                <div className='mt1'>
                  <Select
                    data={endOptions}
                    value={runForever.value}
                    onClose={value => setRunForeverValue(value)}
                    cssClass='mobiscroll-select'
                    touchUi={false}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={UIMessages.trip.recurringTrips.runForever}
                    labelStyle='floating'
                  />
                  {props.runForever === false && (
                    <div className='mt1'>
                      <Input
                        type='number'
                        placeholder={UIMessages.trip.recurringTrips.timeToRecur}
                        min={minimumDaysToRecur}
                        max={maximumDaysToRecur}
                        defaultValue='2'
                        onChange={(event: React.ChangeEvent) => setTimeToOccurVal(event)}
                        className='mobiscroll-input form'
                        theme='ios'
                        themeVariant='light'
                        inputStyle='box'
                        labelStyle='floating'
                      />
                    </div>
                  )}
                </div>
                <div className='flex items-center justify-end mt3'>
                  <button
                    type='button'
                    onClick={cancel}
                    disabled={props.loading}
                    className='custom-btn mbsc-clear-btn mr2'
                  >
                    {UIMessages.common.cancel}
                  </button>
                  <button
                    type='button'
                    onClick={() => onSubmit()}
                    disabled={
                      !(
                        props.cronTabExp !== undefined &&
                        props.timesToRecur !== undefined &&
                        props.runForever !== undefined
                      ) || props.loading
                    }
                    className='SubmitButton custom-btn mbsc-green-btn'
                  >
                    {UIMessages.trip.assign}
                    {props.loading && <MoonLoader sizeUnit={'px'} size={20} color={'#405264'} loading={true} />}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/trips/RecurringTripModal.tsx